
const digest = '5831709574afe57db832650e9803232526389dc781400b083b7c0b0e5086e251';
const css = `._attachment_vsvkf_1 {
  display: inline-block;
  padding: 1px 3px;
}
._attachment_vsvkf_1 ._icon_vsvkf_5 {
  font-size: 22px;
  color: #666;
}
._attachment_vsvkf_1._iconLeft_vsvkf_9 ._icon_vsvkf_5 {
  padding-right: 5px;
}
._attachment_vsvkf_1._iconAbove_vsvkf_12 {
  display: inline-flex;
  flex-direction: column;
  align-items: center;
}
._attachment_vsvkf_1._iconAbove_vsvkf_12 ._icon_vsvkf_5 {
  padding-bottom: 5px;
}
._attachment_vsvkf_1 ._name_vsvkf_20 {
  user-select: none;
}
`;

(function() {
  if (!document.getElementById(digest)) {
    var el = document.createElement('style');
    el.id = digest;
    el.textContent = css;
    document.head.appendChild(el);
  }
})();
    
export default {"attachment":"_attachment_vsvkf_1","icon":"_icon_vsvkf_5","iconLeft":"_iconLeft_vsvkf_9","iconAbove":"_iconAbove_vsvkf_12","name":"_name_vsvkf_20"};
export { css, digest };
  